import React from 'react';
import { DocumentCheckFillIcon, EyeFillIcon, StudentFillIcon, PersonFillIcon, AwardFillIcon, MagicWandFillIcon, RobotFillIcon } from '@applyboard/ui-icons';
import { snakeCaseCapitalizeFirst } from '@applyboard/ui-utils';
import { IconTooltip } from '@applyboard/ui-components';
var iconMapping = {
  hidden: /*#__PURE__*/React.createElement(EyeFillIcon, {
    color: "secondary"
  }),
  applyboardRequirement: /*#__PURE__*/React.createElement(StudentFillIcon, {
    color: "secondary"
  }),
  manual: /*#__PURE__*/React.createElement(PersonFillIcon, {
    color: "secondary"
  }),
  plagiarism: /*#__PURE__*/React.createElement(DocumentCheckFillIcon, {
    color: "secondary"
  }),
  notarization: /*#__PURE__*/React.createElement(AwardFillIcon, {
    color: "secondary"
  }),
  modified: /*#__PURE__*/React.createElement(MagicWandFillIcon, {
    color: "secondary"
  }),
  autoCompleted: /*#__PURE__*/React.createElement(RobotFillIcon, {
    color: "secondary"
  })
};
var friendlyName = {
  applyboardRequirement: 'ApplyBoard Requirement',
  autoCompleted: 'Auto Completed'
};
var SingleFlag = function SingleFlag(_ref) {
  var flag = _ref.flag,
    toolTipMsg = _ref.toolTipMsg;
  var flagIcon = iconMapping[flag];
  var flagName = friendlyName[flag] || snakeCaseCapitalizeFirst(flag);
  return /*#__PURE__*/React.createElement(IconTooltip, {
    title: toolTipMsg || flagName,
    "aria-label": flagName,
    icon: flagIcon
  });
};
export default SingleFlag;